import _ from "lodash";

// Constantes para reutilização
const UNIDADE_VAZIA = ['', '', ''];
const MOEDAS = ['R$', '$', '$'];
const IDIOMAS = ['pt', 'en', 'es'];

// Cache para melhor performance
let cachedIdioma = null;

// Função otimizada para obter idioma
function getIdioma() {
    if (cachedIdioma === null) {
        cachedIdioma = parseInt(localStorage.getItem('idioma') || '0');
    }
    return cachedIdioma;
}

// Função para criar métricas de forma consistente
function criarMetrica(config, simples = false) {
    const idioma = getIdioma();
    if (simples) {
        return {
            title: config.title[idioma],
            value: config.valor || 0
        }
    }
    return {
        unidadeEsq: config.unidadeEsq || UNIDADE_VAZIA,
        unidadeDir: config.unidadeDir || UNIDADE_VAZIA,
        title: config.title,
        valor: config.valor || 0,
        inteiro: config.inteiro || false,
        livre: config.livre || false,
        info: config.info
    };
}

export const relatorioFinanceiro = {
    'IAE': {
        'N': criarMetrica({
            unidadeEsq: UNIDADE_VAZIA,
            title: [
                'Número de Animais',
                'Number of Animals',
                'Número de Animales'
            ],
            valor: 0,
            inteiro: true,
            livre: true
        }),
        'DCONF': criarMetrica({
            unidadeEsq: UNIDADE_VAZIA,
            title: [
                'Dias de Operação',
                'Days of Operation',
                'Días de funcionamiento'
            ],
            valor: 0,
            inteiro: true,
            livre: true
        }),
        'PESO_DE_VENDA': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Peso de Venda (@)',
                'Selling Weight (@)',
                'Peso de Venta (@)'
            ],
            valor: 0
        }),
        'TAP': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Total de Arrobas Produzidas (@)',
                'Total Arrobas Produced (@)',
                'Total de Arrobas Producidas (@)'
            ],
            valor: 0,
            livre: true,
            info: [
                'Total de arrobas produzidas por animal no período, considerando o ganho de peso vivo e o rendimento de carcaça final.(Não considera o rendimento inicial.)',
                'Total arrobas produced per animal in the period, considering live weight gain and final carcass yield. (Does not consider initial yield.)',
                'Total de arrobas producidas por animal durante el período, considerando la ganancia de peso vivo y el rendimiento final de la canal. (No incluye el rendimiento inicial).'
            ]
        }),
        'GDC': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Ganho de Carcaça Total (@)',
                'Total Carcass Gain (@)',
                'Ganancia Total de la Canal (@)'
            ],
            valor: 0,
            info: [
                'Ganho efetivo de carcaça (arrobas) entre o início e o fim do período, considerando a variação no rendimento de carcaça. (Considera o rendimento inicial.)',
                'Effective carcass gain (arrobas) between the beginning and end of the period, considering the variation in carcass yield. (Considers initial yield.)',
                'Ganancia efectiva de la canal (arrobas) entre el inicio y el final del período, considerando la variación en el rendimiento de la canal. (Considera el rendimiento inicial).'
            ]
        }),
        'RG': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Rendimento do Ganho (%)',
                'Gain Yield (@)',
                'Rendimiento de Ganancias (%)'
            ],
            valor: 0
        }),
        'GDiarioC': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Ganho Diário de Carcaça (kg/dia)',
                'Daily Carcass Gain  (kg/day)',
                'Ganancia Diaria de Canal (kg/día)'
            ],
            valor: 0
        }),
        'EFICIENCIA_BIOLOGICA': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Eficiência Biológica (Kg de MS/ @ de carcaça)',
                'Biological Efficiency (Kg of DM/ @ of carcass)',
                'Eficiencia Biológica (Kg de MS / @ de canal)'
            ],
            valor: 0
        }),
        'CUSTO_DIARIO': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo Diário (R$/Cab.)',
                'Daily Cost ($/Head)',
                'Costo Diario ($/Cabeza)'
            ],
            valor: 0
        }),
        'COCAB': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo Operacional (R$/Cab.)',
                'Operational Cost ($/Head)',
                'Costo Operativo ($/Cabeza)'
            ],
            valor: 0
        }),
        'CAR': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Custo de Alimentação / Receita (%)',
                'Food Cost / Revenue (%)',
                'Costo de alimentos / Ingresos (%)'
            ],
            valor: 0,
            livre: true
        }),
        'CTR': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Custo Operacional / Receita (%)',
                'Operational Cost / Revenue (%)',
                'Costo Operacional / Ingresos (%)'
            ],
            valor: 0
        }),
        'COT': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Custo Total / Receita (%)',
                'Total Cost / Revenue (%)',
                'Costo Total / Ingresos (%)'
            ],
            valor: 0,
            livre: true
        }),
        'CAP': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo da Arroba Produzida (R$/@)',
                'Cost of the Produced Arroba ($/@)',
                'Costo de la Arroba Producida ($/@)'
            ],
            valor: 0
        }),
        'PONTO_EQUILIBRIO_PRECO': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Ponto de Equilíbrio (R$/@)',
                'Balance Point Price ($/@)',
                'Precio del punto de equilibrio ($/@)'
            ],
            valor: 0
        }),
        'CUSTO_OPORTUNIDADE_CAPITAL': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo de Oportunidade de Capítal - Juros (R$/Cab.)',
                'Capital Opportunity Cost ($/Head)',
                'Costo de Oportunidad de Capital ($/Cabeza)'
            ],
            valor: 0
        }),
        // 'DIAS_ATE_VENDA_ESCOLHIDA': criarMetrica({
        //     unidadeEsq: UNIDADE_VAZIA,
        //     title: [
        //         'Dias até a Venda Escolhida',
        //         'Days Until Selected Sale',
        //         'Días Hasta la Venta Elegida'
        //     ],
        //     valor: 0,
        //     inteiro: true,
        //     livre: true,
        // }),
        // 'RECEITA_SE_VENDER_HOJE': criarMetrica({
        //     unidadeEsq: MOEDAS,
        //     title: [
        //         'Receita se Vender Hoje (R$/Cab.)',
        //         'Revenue if Sold Today ($/Head)',
        //         'Ingreso si Vende Hoy ($/Cabeza)'
        //     ],
        //     valor: 0,
        //     livre: true
        // }),
        // 'RECEITA_ESTIMADA_DATA_ESCOLHIDA': criarMetrica({
        //     unidadeEsq: MOEDAS,
        //     title: [
        //         'Receita Estimada na Data Escolhida (R$/Cab.)',
        //         'Estimated Revenue on Selected Date ($/Head)',
        //         'Ingreso Estimado en la Fecha Elegida ($/Cabeza)'
        //     ],
        //     valor: 0,
        //     livre: true
        // }),
        // 'CUSTO_MANTER_ATE_DATA': criarMetrica({
        //     unidadeEsq: MOEDAS,
        //     title: [
        //         'Custo para Manter até a Data (R$/Cab.)',
        //         'Cost to Keep Until Date ($/Head)',
        //         'Costo para Mantener Hasta la Fecha ($/Cabeza)'
        //     ],
        //     valor: 0,
        //     livre: true
        // }),
        // 'CUSTO_OPORTUNIDADE_ATE_DATA': criarMetrica({
        //     unidadeEsq: MOEDAS,
        //     title: [
        //         'Custo de Oportunidade até a Data (R$/Cab.)',
        //         'Opportunity Cost Until Date ($/Head)',
        //         'Costo de Oportunidad Hasta la Fecha ($/Cabeza)'
        //     ],
        //     valor: 0,
        //     livre: true
        // }),
        // 'SALDO_LIQUIDO_ESPERAR': criarMetrica({
        //     unidadeEsq: MOEDAS,
        //     title: [
        //         'Saldo Líquido de Esperar (R$/Cab.)',
        //         'Net Gain from Waiting ($/Head)',
        //         'Saldo Neto de Esperar ($/Cabeza)'
        //     ],
        //     valor: 0,
        //     livre: true
        // }),
        'PONTO_EQUILIBRIO_PRECO_COP': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Ponto de Equilíbrio com Juros (R$/@)',
                'Equilibrium Point with Interest ($/@)',
                'Punto de Equilibrio con Interés ($/@)'
            ],
            valor: 0
        }),
        'MARGEM_OPERACIONAL': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Margem Operacional (R$/@)',
                'Operating Margin ($/@)',
                'Margen Operativo ($/@)'
            ],
            valor: 0
        }),
        'MARGEM_OPERACIONAL_CAB': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Margem Operacional (R$/Cab.)',
                'Operating Margin (R$/Head)',
                'Margen Operativo (R$/Cabeza)'
            ],
            valor: 0
        }),
        'RAT': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Lucro por Animal (R$/Cab.)',
                'Earnings per animal ($/Head)',
                'Ganancias por animal ($/Cabeza)'
            ],
            valor: 0
        }),
        'TAXA_RETORNO_INVESTIMENTO_ANO': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Taxa de Retorno do Investimento (% a.a.)',
                'Rate of Return on Investment (% yoy)',
                'Tasa de Retorno de la Inversión (% i.a.)'
            ],
            valor: 0
        }),
        'TAXA_RETORNO_INVESTIMENTO_ANO_COP': criarMetrica({
            unidadeDir: UNIDADE_VAZIA,
            title: [
                'Taxa de Retorno do Investimento com Juros (% a.a.)',
                'Return on Investment Rate with Interest (% yoy)',
                'Tasa de Retorno de la Inversión con Interés (% i.a.)'
            ],
            valor: 0
        })
    },
    'ATC': {
        'IA': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Investimento em Animais (R$)',
                'Animal Purchase Cost ($)',
                'Costo de Compra de Animales ($)'
            ],
            valor: 0
        }),
        'CALT': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo com Alimentação (R$)',
                'Cost with Food ($)',
                'Costo con Alimentos ($)'
            ],
            valor: 0,
            livre: true
        }),
        'OC': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custos Extras (R$)',
                'Extra Costs ($)',
                'Costos Adicionales ($)'
            ],
            valor: 0
        }),
        'CT': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Custo Operacional (R$)',
                'Operational Cost ($)',
                'Costo Operativo ($)'
            ],
            valor: 0
        }),
        'RBT': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Receita Bruta (R$)',
                'Total Revenue (R$)',
                'Ingresos Totales (R$)'
            ],
            valor: 0,
            livre: true
        }),
        'RTA': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Margem Bruta Total (R$)',
                'Total Gross Margin ($)',
                'Margen Bruto Total ($)'
            ],
            valor: 0
        }),
        'RTPAA': criarMetrica({
            unidadeEsq: MOEDAS,
            title: [
                'Receita Total com Preço de Arrobas Adquiridas (R$)',
                'Total Revenue with Price of Purchased Arrobes ($)',
                'Ingresos Totales con Precio de Arrobes Comprados ($)'
            ],
            valor: 0,
            livre: true
        })
    }
};

export const relatorioFinanceiroMobile = (function() {
    const mobile = {};
    
    Object.keys(relatorioFinanceiro).forEach(secao => {
        mobile[secao] = {};
        Object.keys(relatorioFinanceiro[secao]).forEach(chave => {
            mobile[secao][chave] = criarMetrica(relatorioFinanceiro[secao][chave], true);
        });
    });
    
    return mobile;
})();


// MELHORIA: Funções utilitárias para trabalhar com o relatório
export const RelatorioUtils = {
    // Atualizar valor de uma métrica
    atualizarValor(secao, chave, novoValor) {
        if (relatorioFinanceiro[secao] && relatorioFinanceiro[secao][chave]) {
            relatorioFinanceiro[secao][chave].valor = novoValor;
            return true;
        }
        return false;
    },

    // Obter valor de uma métrica
    obterValor(secao, chave) {
        return _.get(relatorioFinanceiro, secao + '.' + chave + '.valor', 0);
    },

    // Obter texto traduzido
    obterTexto(secao, chave, idioma = null) {
        if (!idioma) idioma = getIdioma();
        const metrica = _.get(relatorioFinanceiro, secao + '.' + chave, null);
        if (!metrica) return '';
        
        return {
            titulo: metrica.title[idioma] || metrica.title[0],
            unidadeEsq: metrica.unidadeEsq[idioma] || metrica.unidadeEsq[0],
            unidadeDir: metrica.unidadeDir[idioma] || metrica.unidadeDir[0],
            info: _.get(metrica, 'info[' + idioma + ']', null) || _.get(metrica, 'info[0]', '')
        };
    },

    // Resetar todos os valores para zero
    resetarValores() {
        Object.keys(relatorioFinanceiro).forEach(secao => {
            Object.keys(relatorioFinanceiro[secao]).forEach(chave => {
                relatorioFinanceiro[secao][chave].valor = 0;
            });
        });
    }
};

export default relatorioFinanceiro;
